import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';

import { IAppState } from '@store';
import { withAutoUpdate } from '@flux';
import { mainStatusActionsPack } from '@status/actions';
import { mainStatusSelectorsPack } from '@status/selectors';
import { mainPlatformActionsPack } from '@platform/actions';
import { mainPlatformSelectorsPack } from '@platform/selectors';
import XStatusEntry, { StatusEntryProps as XStatusEntryProps } from './entry.view';


export type StatusEntryProps = {
	fetchStatus?: typeof mainStatusActionsPack.actions.fetchStatus;
	fetchTenantAccount?: typeof mainPlatformActionsPack.actions.fetchTenantAccount;
} & Partial<Pick<XStatusEntryProps, 'statusIsFetching' | 'tenantIsFetching' | 'tariff' | 'status' | 'tenantID'>>;

const StatusEntry: React.FC<StatusEntryProps> = (props) => {
	const {
		statusIsFetching,
		tenantIsFetching,
		tariff,
		status,
		tenantID,
		fetchStatus,
		...rest
	} = props;

	return (
		<XStatusEntry
			{...rest}
			statusIsFetching={statusIsFetching}
			tenantIsFetching={tenantIsFetching}
			tariff={tariff}
			status={status}
			tenantID={tenantID}
		/>
	);
}

StatusEntry.displayName = 'StatusEntry';
StatusEntry.defaultProps = {};

function mapStateToProps(state: IAppState): Partial<StatusEntryProps> {
	return {
		statusIsFetching: mainStatusSelectorsPack.selectAsyncStatus.selectIsFetching(state),
		tenantIsFetching: mainPlatformSelectorsPack.selectAsyncTenantAccount.selectIsFetching(state),
		tariff: mainPlatformSelectorsPack.selectActiveTariff(state),
		status: mainStatusSelectorsPack.selectAsyncStatus.selectItem(state),
		tenantID: mainPlatformSelectorsPack.selectTenantID(state),
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return bindActionCreators({
		fetchStatus: mainStatusActionsPack.actions.fetchStatus,
		fetchTenantAccount: mainPlatformActionsPack.actions.fetchTenantAccount,
	}, dispatch);
}

export default withAutoUpdate(mapStateToProps, mapDispatchToProps)({
	statusDidInvalidate: [
		mainStatusSelectorsPack.selectAsyncStatus.selectDidInvalidate,
		({ fetchStatus }) => fetchStatus(),
	],
	tenantDidInvalidate: [
		mainPlatformSelectorsPack.selectAsyncTenantAccount.selectDidInvalidate,
		({ tenantID, fetchTenantAccount }) => fetchTenantAccount(tenantID),
	],
})(StatusEntry);
